import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'left-arrow';

const originalDimensions = {
    width: 24,
    height: 24,
};

export const IconLeftArrow = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;
    const classNames = cx(addClasses, 'inline');

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Left Arrow Icon</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <rect
                    fill={fill}
                    opacity=".3"
                    transform="matrix(0 -1 -1 0 24 24)"
                    x="11"
                    y="5"
                    width="2"
                    height="14"
                    rx="1"
                />
                <path
                    d="M12.707 17.293a1 1 0 11-1.414 1.414l-6-6a1 1 0 01-.03-1.383l5.5-6a1 1 0 111.474 1.352L7.384 11.97l5.323 5.323z"
                    fill={fill}
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};
